import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import { modelOf } from '../../../prop-types';
import AdStore from '../../../store/AdStore';
import ConfigStore from '../../../store/ConfigStore';
import UIStore from '../../../store/UIStore';
import AdZones from '../../../types/AdZones';
import { resolveMainFooterBannerSlot } from '../bannerMedia';
import BannerSlider from '../BannerSlider/BannerSliderSlides';

const MainBanner = ({
  adStore,
  configStore,
  uiStore,
  bannerPage,
  className,
  searchParams,
  overrideSettings,
}) => {
  const pageKey = bannerPage || searchParams?.bannerPage;
  const {
    aspectRatio,
    maximumCrossAxisSize,
    infinite,
    centerMode,
    contentJustify,
    useCreativeSlideWidth,
  } = resolveMainFooterBannerSlot({
    adZone: AdZones.MAIN_BANNER,
    configStore,
    uiStore,
    adStore,
    bannerPage: pageKey,
  });

  return (
    <BannerSlider
      adZone={AdZones.MAIN_BANNER}
      searchParams={{ ...searchParams }}
      className={classNames('MainBanner', className)}
      aspectRatio={aspectRatio}
      maximumCrossAxisSize={maximumCrossAxisSize}
      slideContentJustify={contentJustify}
      useCreativeSlideWidth={useCreativeSlideWidth}
      overrideSettings={{
        ...overrideSettings,
        infinite,
        centerMode,
      }}
    />
  );
};

MainBanner.propTypes = {
  adStore: modelOf(AdStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  bannerPage: PropTypes.string,
  className: PropTypes.string,
  overrideSettings: PropTypes.object,
  searchParams: PropTypes.object,
};

export default inject(
  'adStore',
  'configStore',
  'uiStore'
)(observer(MainBanner));
